import { colorClasses } from "../constants/color";
import { CircleLoading } from "../icons/CircleLoading";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	onClick?: () => void;
	className?: string;
	isLoading?: boolean;
	color?: "red" | "blue" | "green" | "roseWhite" | "purple" | "violet" | "mutedViolet" | "orange" | "yellow";
	sizeLoading?: string;
	secondary?: boolean;
	size?: "sm" | "md" | "lg";
	children: React.ReactNode;
	isDisabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
	onClick,
	children,
	className = "",
	isLoading = false,
	isDisabled = false,
	color = "",
	size = "md",
	sizeLoading = "w-6 h-6",
	secondary = false,
	...props
}) => {
	const themeColor = colorClasses[secondary ? "secondary" : "primary"][color] || colorClasses[secondary ? "secondary" : "primary"].default;
	const sizeClasses = {
		sm: "max-md:text-xs text-sm px-4 py-2",
		md: "max-md:text-sm text-md px-6 py-3",
		lg: "max-md:text-md text-lg px-7 py-4",
	};
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={isLoading || isDisabled}
			className={`shadow-md flex justify-center select-none rounded-md items-center ${className}
                transition-colors duration-300 ${sizeClasses[size]} ${themeColor} ${isLoading || isDisabled ? "cursor-not-allowed opacity-60 pointer-events-none" : "cursor-pointer"}`}
			{...props}
		>
			{isLoading ? <CircleLoading className={sizeLoading} /> : children}
		</button>
	);
};
